import * as yup from 'yup';

export const eSignedValidation = yup
  .boolean()
  .nullable()
  // eslint-disable-next-line func-names
  .test('is-e-signed', 'You must answer Yes in order to open this account', function(value) {
    return !!value;
  });
